export const getInitialStyle = () => ({
  AuxiliaryButtons: {
    zIndex: 1,
    SkipChapterButton: {
      mount: 1,
    },
  },
});
